module.exports = __webpack_public_path__ + "img/Creditos_activo.d496a7bb.svg";